<template>
  <div id="app" class="loading">
    <Header />
    <!-- <Nav /> -->
    <router-view v-if="isRouterAlive" />
    <Footer />
    <!-- <div hidden>The only Audi authorized pre-owned centre in Hong Kong, 100% proven quality. Explore the one-stop service now! Enquiry: 22910000. 奧迪認可易手車中心，全港唯一原廠認證，100%品質保證，立即體驗一站式交易服務，查詢請致電22910000。</div> -->
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
// import Nav from "./components/Nav";

export default {
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  components: {
    Header,
    Footer,
    // Nav,
  },
  mounted() {
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
      
      // setTimeout(()=> {
      //   this.isRouterAlive = true
      // }, 200)
    }
  },
  watch: {
    '$route': () => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },

  }
};
</script>

<style>
@import "../static/font.css";
@import "../static/style.css";
</style>

<style lang="stylus">


.hei {
  font-family: "微軟正黑體" !important;
}


.el-popover {
    max-width: 288px;
    color: #fff !important;
    border: none !important;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, .05), 0 0 50px 0 rgba(0, 0, 0, .07);
    background: #4c4c4c !important;
    word-break: keep-all; 
    text-align: left !important;
}
.el-popover.normal {
  word-break: normal; 
}

.el-popover[x-placement^=bottom] .popper__arrow{
    /*el-popover上边三角下层的颜色---也就是视觉上的边框*/
    border-bottom-color: rgba(76, 76, 76, 1) !important;
}
.el-popover[x-placement^=bottom] .popper__arrow::after{
    /*el-popover上边三角表层的颜色---也就是视觉上的角*/
    border-bottom-color: rgba(76, 76, 76, 1) !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue